import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Button, Card, CardBody } from "react-bootstrap";
import ServerTable from "../../../lib/ServerTable";
import getFuelRateColumns from "./columns/FuelRateColumns";
import { ConfirmModal, SuccessToolbar, ErrorToolbar } from "../../../lib/formControls";
import FuelRateEdit from "./FuelRateEdit";

export default function FuelRate() {

   const navigate = useNavigate();
   const roleKeyVal = localStorage.getItem("roleKey");
   const entityId = localStorage.getItem("entityId");
   let enblAct = false;
   if(roleKeyVal === 'bunk_incharge' && entityId != "") {
        if(entityId) {
          enblAct = true;
        } else {
          navigate('/');
        }
   }

  const [rowEditData, setRowEditData] = useState({});
  const [showEditForm, setShowEditForm] = useState(false);
  const [customSearch, setCustomSearch] = useState('');
  const [customerror, setCustomerror] = useState('');
  const [roleKey, setRoleKey] = useState(roleKeyVal);
  const [searchObjVal, setSearchObjVal] = useState('');
  const [enableAction, setEnableAction] = useState(enblAct);
  const [tableKey, setTableKey] = useState(0);

  useEffect(() => {
        const searchObj = {};
        if(roleKeyVal === 'bunk_incharge') {
            searchObj.filter = 'entityId|'+entityId;
        }
        setSearchObjVal(searchObj);
        setTableKey(prev => prev + 1);
  }, [
    roleKey
  ]);

  const handlefuelRateEditCancel = () => {
        setShowEditForm(false);
  };

  const handleSearchChange = (e) => {
    setCustomSearch(e.target.value);
  };

  const handleEditfuelRate = (rowDetails) => {
      setRowEditData(rowDetails);
      setShowEditForm(true);
  };


  const columns = getFuelRateColumns(handleEditfuelRate,enableAction);

  const handleAct = () => {
        setShowEditForm(false);
        setTableKey(prev => prev + 1);
  }

  return (<div className="fuelrate-management-page">
          <Container fluid>
            <div className='page-title-main'>
              <h5 className='page-title'>Fuel Rate Management</h5>
              <p className='page-info'>Manage fuel rate based on petrol bunks.</p>
            </div> 
            <div className='page-content-main'>
              {customerror && <ErrorToolbar message={`⚠️ ${customerror}`} />}

              <div className='filter-action-main'>
                    {(roleKeyVal === 'super_admin') && <Row className="mb-2">
                        <Col xs={12} sm={12} md={12}>
                            <div className='input-filter-action'>
                                <input type="text" id="customSearch" name='customSearch' placeholder="Search by bunk name & location" value={customSearch} onChange={handleSearchChange} />
                            </div>
                        </Col>
                    </Row>}
              </div>

              <Row>
                <Col xs="12">
                      <div className='tablelist-maindiv'>
                          <ServerTable
                            key={tableKey}
                            apiUrlTxt="entities"
                            columns={columns}
                            customParams={searchObjVal}
                            showSearch={false}
                            showAddBtn={false}
                            addBtn={{ label: '', url: `` }}
                            srlNumbr={false}
                            customSearch={true}
                            customSearchTxt={customSearch}
                          />
                      </div>
                
                </Col>
              </Row>
            </div>   

            <FuelRateEdit
              show={showEditForm}
              onHide={handlefuelRateEditCancel}
              fuelRateDetails={rowEditData}
              handleAct={handleAct}
            />

          </Container>
        </div>);
}
